var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-content-center mb-1" },
      [
        _vm.loadingSpinner
          ? _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", span: "Spinning", block: "" },
            })
          : _vm._e(),
      ],
      1
    ),
    !_vm.loadingSpinner
      ? _c(
          "section",
          { staticClass: "invoice-add-wrapper" },
          [
            _c(
              "b-row",
              { staticClass: "invoice-add" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", xl: "9", md: "8" } },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c(
                          "b-card",
                          {
                            staticClass: "invoice-preview-card",
                            attrs: { "no-body": "" },
                          },
                          [
                            _c(
                              "b-card-body",
                              { staticClass: "invoice-padding pb-0" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0",
                                  },
                                  [
                                    _c("Logo"),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "invoice-number-date mt-md-0 mt-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center justify-content-md-end mb-1",
                                          },
                                          [
                                            _c(
                                              "h4",
                                              { staticClass: "invoice-title" },
                                              [_vm._v("Purchase Order")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center mb-1",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "title" },
                                              [_vm._v(" Date: ")]
                                            ),
                                            _c("flat-pickr", {
                                              staticClass:
                                                "form-control invoice-edit-input",
                                              attrs: {
                                                config: _vm.config.wrap,
                                              },
                                              model: {
                                                value: _vm.issuedDate,
                                                callback: function ($$v) {
                                                  _vm.issuedDate = $$v
                                                },
                                                expression: "issuedDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "title" },
                                              [_vm._v(" Due Date: ")]
                                            ),
                                            _c("flat-pickr", {
                                              staticClass:
                                                "form-control invoice-edit-input",
                                              attrs: {
                                                config: _vm.configDue.wrap,
                                              },
                                              model: {
                                                value: _vm.dueDate,
                                                callback: function ($$v) {
                                                  _vm.dueDate = $$v
                                                },
                                                expression: "dueDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c("hr", { staticClass: "invoice-spacing" }),
                            _c(
                              "b-card-body",
                              { staticClass: "invoice-padding pt-0" },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "invoice-spacing" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-lg-1",
                                        attrs: { cols: "6", xl: "6" },
                                      },
                                      [
                                        _c("h6", { staticClass: "mb-2" }, [
                                          _vm._v("Choose Supplier:*"),
                                        ]),
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.optionsCustomer,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.supplierSelected(
                                                _vm.supplierId
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.supplierId,
                                            callback: function ($$v) {
                                              _vm.supplierId = $$v
                                            },
                                            expression: "supplierId",
                                          },
                                        }),
                                        _vm.whenSelected !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "mt-1" },
                                              [
                                                _c(
                                                  "b-card-text",
                                                  { staticClass: "mb-25" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.whenSelected.name
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-card-text",
                                                  { staticClass: "mb-25" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.whenSelected.email
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-card-text",
                                                  { staticClass: "mb-25" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.whenSelected
                                                            .address
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-card-text",
                                                  { staticClass: "mb-25" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.whenSelected
                                                            .phoneNumber
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-card-text",
                                                  { staticClass: "mb-0" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.whenSelected
                                                            .contactPerson
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-lg-1",
                                        attrs: { cols: "6", xl: "6" },
                                      },
                                      [
                                        _c("h6", { staticClass: "mb-2" }, [
                                          _vm._v("Choose Warehouse:*"),
                                        ]),
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.optionsWarehouse,
                                          },
                                          model: {
                                            value: _vm.warehouseId,
                                            callback: function ($$v) {
                                              _vm.warehouseId = $$v
                                            },
                                            expression: "warehouseId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-card-body",
                              { staticClass: "invoice-padding " },
                              [
                                _c(
                                  "div",
                                  { ref: "form", staticClass: "repeater-form" },
                                  [
                                    _c(
                                      "b-row",
                                      { ref: "row", staticClass: "pb-2" },
                                      [
                                        _c("b-col", { attrs: { cols: "12" } }, [
                                          _c(
                                            "div",
                                            { staticClass: "d-none d-lg-flex" },
                                            [
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass:
                                                    "flex-grow-1 p-2",
                                                },
                                                [
                                                  _c(
                                                    "b-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        lg: "6",
                                                      },
                                                    },
                                                    [_vm._v(" Item* ")]
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        lg: "2",
                                                      },
                                                    },
                                                    [_vm._v(" Unit (Rs) ")]
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        lg: "2",
                                                      },
                                                    },
                                                    [_vm._v(" Qty ")]
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        lg: "2",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Total Price (Rs)"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("div", {
                                                staticClass:
                                                  "form-item-action-col",
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex border rounded",
                                            },
                                            [
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass:
                                                    "flex-grow-1 p-2",
                                                },
                                                [
                                                  _c(
                                                    "b-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        lg: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-inline d-lg-none",
                                                        },
                                                        [_vm._v("Item*")]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.productID.name
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        lg: "2",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-inline d-lg-none",
                                                        },
                                                        [_vm._v("Unit Price")]
                                                      ),
                                                      _c("b-form-input", {
                                                        staticClass: "mb-2",
                                                        attrs: {
                                                          type: "number",
                                                          readonly: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.productID
                                                              .purchasePrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.productID,
                                                              "purchasePrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "productID.purchasePrice",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        lg: "2",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-inline d-lg-none",
                                                        },
                                                        [_vm._v("Qty")]
                                                      ),
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            rules:
                                                              "required|min_value:1",
                                                            name: "Quantity",
                                                            vid: "Quantity",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function (
                                                                  ref
                                                                ) {
                                                                  var errors =
                                                                    ref.errors
                                                                  return [
                                                                    _c(
                                                                      "b-form-input",
                                                                      {
                                                                        staticClass:
                                                                          "mb-2",
                                                                        attrs: {
                                                                          type: "number",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.quantity,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.quantity =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "quantity",
                                                                        },
                                                                      }
                                                                    ),
                                                                    errors.length
                                                                      ? _c(
                                                                          "small",
                                                                          {
                                                                            staticClass:
                                                                              "text-danger",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                errors[0]
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3495438567
                                                          ),
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        lg: "2",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-inline d-lg-none",
                                                        },
                                                        [_vm._v("Total Price")]
                                                      ),
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-1" },
                                                        [
                                                          _vm._v(
                                                            "Rs " +
                                                              _vm._s(
                                                                _vm.computedPrice
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        lg: "12",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-textarea", {
                                                        staticClass:
                                                          "mb-2 mb-lg-0",
                                                        model: {
                                                          value:
                                                            _vm.productID
                                                              .description,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.productID,
                                                              "description",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "productID.description",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "ripple",
                                        rawName: "v-ripple.400",
                                        value: "rgba(255, 255, 255, 0.15)",
                                        expression:
                                          "'rgba(255, 255, 255, 0.15)'",
                                        modifiers: { 400: true },
                                      },
                                    ],
                                    attrs: { size: "sm", variant: "primary" },
                                    on: { click: _vm.addNewItemInItemForm },
                                  },
                                  [_vm._v(" Add Item ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-card-body",
                              { staticClass: "invoice-padding pb-0" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "mt-md-0 mt-3 d-flex align-items-center",
                                        attrs: {
                                          cols: "12",
                                          md: "6",
                                          order: "2",
                                          "order-md": "1",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-nowrap mr-50",
                                            attrs: {
                                              for: "invoice-data-sales-person",
                                            },
                                          },
                                          [_vm._v("Issuer:*")]
                                        ),
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.optionsSalesPerson,
                                          },
                                          model: {
                                            value: _vm.salesPersonId,
                                            callback: function ($$v) {
                                              _vm.salesPersonId = $$v
                                            },
                                            expression: "salesPersonId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "mt-md-6 d-flex justify-content-end",
                                        attrs: {
                                          cols: "12",
                                          md: "6",
                                          order: "1",
                                          "order-md": "2",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "invoice-total-wrapper",
                                          },
                                          [
                                            _c("hr", { staticClass: "my-50" }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "invoice-total-item",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "invoice-total-title",
                                                  },
                                                  [_vm._v("Total:")]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "invoice-total-amount",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Rs " +
                                                        _vm._s(
                                                          _vm.computedPrice
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("hr", { staticClass: "invoice-spacing" }),
                            _c(
                              "b-card-body",
                              { staticClass: "invoice-padding pt-0" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Note: ")]
                                ),
                                _c("b-form-textarea", {
                                  model: {
                                    value: _vm.note,
                                    callback: function ($$v) {
                                      _vm.note = $$v
                                    },
                                    expression: "note",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass: "invoice-actions mt-md-0 mt-2",
                    attrs: { cols: "12", md: "4", xl: "3" },
                  },
                  [
                    _c(
                      "b-card",
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(113, 102, 240, 0.15)",
                                expression: "'rgba(113, 102, 240, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            style: _vm.loadingButton
                              ? { cursor: "not-allowed" }
                              : {},
                            attrs: {
                              variant: "outline-primary",
                              block: "",
                              disabled: _vm.loadingButton,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addSalesOrder()
                              },
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _vm._e(),
                            _vm._v(" Save "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }